import React from 'react';
import PropTypes from 'prop-types';

import ReactRouterPropTypes from 'react-router-prop-types';

import axios from "axios";

import { READ } from './Om7Sense';
import { ReportingPageTabs } from './ReportingComponents/ReportingPageTabs.js';

const columns = [
    {
        Header: "Model",
        id: "model",
        accessor: "model"
    },
    {
        Header: "Version",
        id: "firmwareVersion",
        accessor: "firmwareVersion"
    },
    {
        Header: "# with this firmware",
        id: "count",
        accessor: d => d.uuids.length,
        aggregate: vals => vals.reduce((a, b) => a + b, 0),
        filterable: false
    },
    {
        Header: "# being updated",
        id: "updated",
        accessor: d => 0,
        aggregate: vals => vals.reduce((a, b) => a + b, 0),
        filterable: false
    },
];

class ReportFirmwarePage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    state = {
        data: [],
        permission: this.context.p.checkPermission(READ, "/api/devinfo"),
        ReactTable: null
    };

    static contextTypes = {
        t: PropTypes.func.isRequired,
        p: PropTypes.object.isRequired
    }

    static propTypes = {
        history: ReactRouterPropTypes.history.isRequired,
        location: ReactRouterPropTypes.location.isRequired,
        match: ReactRouterPropTypes.match.isRequired
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.data === null || this.state.data.length !== nextState.data.length || nextState.ReactTable !== this.state.ReactTable;
    }

    componentDidMount() {
        const self = this;
        import(/* webpackChunkName: "react-table-6" */ 'react-table-6').then(({ default: _ }) => {
            self.setState({
                ReactTable: _
            });
        });
        
        axios.get('/api/devinfo?queryDevList=vendor,firmwareVersion,model')
            .then(function (response) {
                const res = [];
                const modelMap = {};

                const data = response.data;
                for (let uuid in data) {
                    const row = data[uuid];
                    const model = row.vendor + " " + row.model;
                    if (modelMap[model] === undefined) {
                        modelMap[model] = {};
                    }
                    let modelFw = modelMap[model][row.firmwareVersion];
                    if (modelFw === undefined) {
                        modelFw = [];
                        modelMap[model][row.firmwareVersion] = modelFw;
                    }

                    modelFw.push(uuid);
                }

                for (let model in modelMap) {
                    for (let firmwareVersion in modelMap[model]) {
                        res.push({model, firmwareVersion, uuids: modelMap[model][firmwareVersion]});
                    }
                }
                self.setState({data: res});
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {
        const t = this.context.t;

        const ReactTable = this.state.ReactTable;

        if (ReactTable === null) {
            return null;
        }

        return (
            <React.Fragment>
                <ReportingPageTabs location={this.props.location} />
                { !this.state.permission ? (
                    <div className="empty">
                        <div className="empty-icon">
                            <i className="icon icon-people"></i>
                        </div>
                        <p className="empty-title h5">{ t("reporting.no_permission") }</p>
                    </div>
                ) : (
                    <div className="overview">
                        <ReactTable
                            data={this.state.data}
                            columns={columns}
                            pivotBy={["model"]}
                            defaultPageSize={10}
                            showPagination={false}
                            className="-striped -highlight"
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }
}


export default ReportFirmwarePage;